/**
 * Shared helper for gating React Query hooks on auth state.
 *
 * Usage:
 *   const authed = useAuthEnabled();
 *   useGetQuotesFavorites({ query: { enabled: authed } });
 *
 * Pairs with `AuthErrorPrompt` to render a friendly sign-in nudge
 * instead of letting protected queries 401 on signed-out visitors.
 */
import { useAuth } from "@/contexts/AuthContext";

export function useAuthEnabled(): boolean {
  const { currentUser } = useAuth();
  return !!currentUser;
}
